<template>
  <div>
       <div id="navigation">
        <nav class="hidden md:block md:flex justify-between items-center">
            <div class="w-40"> <img src="../../assets/siban.jpeg" alt=""></div>
            <ul class=" flex justify-between items-center">
                <li class="mx-10 text-indigo-600 font-medium">Vote Now</li>
                <li class="mx-10 text-indigo-600 font-medium"><router-link to="/home">Candidates</router-link></li>
                <li class="mx-10 text-indigo-600 font-medium">About</li>
                 <router-link to="/create"
                class="px-4 py-2 border border-indigo-600 text-white font-medium bg-indigo-600 rounded hover:text-indigo-600 hover:bg-white transition focus:outline-none text-sm"
              >
               Add Candidate
                 </router-link>
               
            </ul>
        </nav>
             <!-- MOBILE LOGO -->
        <div class="w-1/2 mb-8 md:hidden"> <img src="../../assets/siban.jpeg" alt=""></div>
    </div>

    <!-- MOBILE TOGGLE -->
    <div @click="openNavigation" class="md:hidden fixed top-0 right-0 bg-indigo-600 p-5 text-white z-20">
        <i ref="icon" class="fas fa-bars fa-lg"></i>
    </div>

    <!-- MOBILE NAVIGATION -->
    <div ref="mobileMenu" class="hidden h-full w-full z-10 bg-white fixed top-0 left-0">
        <ul class="md:hidden pt-40 pl-4">
            <li class="mt-4 text-xl text-indigo-600 font-medium">Vote Now</li>
            <li class="mt-4 text-xl text-indigo-600 font-medium"><router-link to="/home">Candidates</router-link></li>
            <li class="mt-4 text-xl text-indigo-600 font-medium">About</li>
             <router-link to="/create"
                class="mt-4 inline-block py-2 px-2 border border-indigo-600 text-white font-medium bg-indigo-600 rounded hover:text-indigo-600 hover:bg-white transition focus:outline-none md:text-sm"
              >
               Add Candidate
             </router-link>
        </ul>

    </div>
  </div>
</template>

<script>
export default {
    methods:{
        openNavigation(){
             const mobileMenu = this.$refs["mobileMenu"]
             const icon = this.$refs["icon"]
            icon.classList.toggle('fa-times')
             mobileMenu.classList.toggle('hidden')

     }
    },

}
</script>

